import { Currency as CurrencyEnum, DEFAULT_CURRENCY } from '@/api/rest/resources/types/currency';
import { NO_DATA_PLACEHOLDER } from '@/config/constants';
import { useDefaultCurrency } from '@/hooks/useDefaultCurrency';
import { getDisplayCurrency } from '@/hooks/useDisplayCurrency';
import { useUserContext } from '@/lib/auth';

type CurrencyProps = {
  value?: number | string;
  currency?: string;
  options?: Intl.NumberFormatOptions;
};

export const Currency = (props: CurrencyProps & { stewardedValue?: unknown }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { value, currency, options, stewardedValue, ...delegated } = props;

  if (value === undefined) {
    return <span {...delegated}>{NO_DATA_PLACEHOLDER}</span>;
  }
  return <CurrencyValue value={value} currency={currency} options={options} {...delegated} />;
};

const CurrencyValue = (props: CurrencyProps) => {
  const { value, currency, options, ...delegated } = props;

  const amountDisplay = useFormattedCurrency(value ?? '', currency, options);

  return <span {...delegated}>{amountDisplay}</span>;
};
export const useFormattedCurrency = (value: number | string, currency?: string, options?: Intl.NumberFormatOptions) => {
  const { user } = useUserContext();
  const orgCurrency = useDefaultCurrency();

  const conversionRate = user?.membership?.organization?.conversion_rate ?? 1;

  const displayValue =
    orgCurrency !== DEFAULT_CURRENCY && conversionRate
      ? // Backend always sends monetary values in EUR, so we need to convert them to org currency
        Number(value) * conversionRate
      : Number(value);
  const displayCurrency = currency === CurrencyEnum.EUR || !currency ? orgCurrency : currency;

  return getDisplayCurrency(displayValue, window.navigator.language, displayCurrency, options);
};
